var exports = {
  "k": "x804f0401--704ba8--container",
  "O": "x804f0401--704ba8--more",
};

module.exports = exports;
